<template>
  <div
    class="custom-message-component-ConstrainedBox"
    :style="{...constrainedBoxItem}"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { CustomMessageConstrainedBoxComponent } from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { defineComponent, PropType, toRaw } from 'vue';


export default defineComponent({
  name: 'CustomMessageConstrainedBox',
  props: {
    attr: {
      type: Object as PropType<CustomMessageConstrainedBoxComponent>,
      required: true,
    },
  },
  setup(props) {
    let scale = 1;
    const constraints = toRaw(props.attr.constraints);
    const constrainedBoxItem = {
      minWidth: constraints.minWidth ? `${constraints.minWidth * scale}px` : '',
      minHeight: constraints.minHeight ? `${constraints.minHeight * scale}px` : '',
      maxWidth: constraints.maxWidth ? `${constraints.maxWidth * scale}px` : '',
      maxHeight: constraints.maxHeight ? `${constraints.maxHeight * scale}px` : '',
    };
    if (props.attr.scale) {
      scale = toRaw(props.attr.scale);
    }
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    return {
      clickHandle, constrainedBoxItem,
    };
  },

});

</script>
<style lang='scss'>
</style>

